module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightTextH"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Grub Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("4 Rainham Close")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("Copyright © 2008 Grub Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Copyright text © 2008 Norman Franks and")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Wing Commander Bob Foster DFC AE")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A CIP catalogue record for this book is available from the British Library")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISBN 978 1 906502 26 3")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("eISBN 9781908117588")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("Cover design by Lizzie B Design")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("Formatted by Pearl Graphics, Hemel Hempstead")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextHA"
  }, [_vm._v("Grub Street only uses FSC")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("(Forest Stewardship Council) paper for its books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368c4d31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_TallyHo_copyright.vue
// module id = 60
// module chunks = 0